'use strict'

export default class forgetpassword {
    constructor(
        email = "",
        codesegurity = "",
        password = ""
    ) {
        this.email = email
        this.codesegurity = codesegurity
        this.password = password
    }

}